import {NgModule} from '@angular/core'
import {AsyncPipe, NgClass, NgOptimizedImage} from '@angular/common'
import {PublicProProfilePageComponent} from './public-pro-profile-page.component'
import {RouterModule} from '@angular/router'
import {PublicProProfileResolver} from './public-pro-profile-resolver.service'
import {HeroCoverModule} from '../../../shared/components/hero-cover/hero-cover.module'
import {TranslocoDirective} from '@ngneat/transloco'
import {DisplayModule} from '../../../craft/display/display.module'
import {ProfileBadgeComponent} from './profile-badge/profile-badge.component'
import {FaIconComponent} from '@fortawesome/angular-fontawesome'
import {LanguageFlagComponent} from './language-flag/language-flag.component'
import {GallerizeDirective} from 'ng-gallery/lightbox'
import {GalleryImageDef, GalleryModule} from 'ng-gallery'
import {LocationsModule} from '../../../craft/locations/locations.module'
import {BreadcrumbsModule} from '../../../craft/breadcrumbs/breadcrumbs.module'
import {ProfileIntroductionComponent} from '../../../craft/profile-introduction/profile-introduction.component'
import {ButtonModule} from '../../../craft/button/button.module'
import {OpenContactModalOnClickDirective} from '../../../shared/directives/open-contact-modal/open-contact-modal.directive'
import {GoogleRatingComponent} from '../../../craft/google-rating/google-rating.component'
import {RemoveAgencyPrefixPipe} from '../../../shared/pipes/remove-agency-prefix.pipe'
import {BrandingModule} from '../../../shared/components/branding/branding.module'
import {StickyBottomNavigationModule} from '../../../shared/components/sticky-bottom-navigation/sticky-bottom-navigation.module'
import {AverageGooglePlacePipe} from '../../../shared/pipes/average-google-place.pipe'
import {OfferingsSectionComponent} from '../../../shared/components/content/offerings-section/offerings-section.component'
import {ContentSectionComponent} from '../../../craft/content-section/content-section.component'
import {RecommendedByComponent} from '../../../craft/recommended-by/recommended-by.component'
import {GalleryComponent} from '../../../shared/components/gallery/gallery.component'

@NgModule({
  declarations: [PublicProProfilePageComponent, ProfileBadgeComponent, LanguageFlagComponent],
  imports: [
    RouterModule.forChild([
      {
        path: ':slug',
        pathMatch: 'full',
        component: PublicProProfilePageComponent,
        resolve: {
          pro: PublicProProfileResolver,
        },
      },
    ]),
    HeroCoverModule,
    AsyncPipe,
    TranslocoDirective,
    BreadcrumbsModule,
    NgOptimizedImage,
    ProfileIntroductionComponent,
    NgClass,
    BrandingModule,
    AverageGooglePlacePipe,
    RemoveAgencyPrefixPipe,
    GoogleRatingComponent,
    ButtonModule,
    FaIconComponent,
    OpenContactModalOnClickDirective,
    DisplayModule,
    OfferingsSectionComponent,
    ContentSectionComponent,
    LocationsModule,
    StickyBottomNavigationModule,
    GalleryModule,
    GalleryImageDef,
    GallerizeDirective,
    RecommendedByComponent,
    GalleryComponent,
  ],
})
export class PublicProProfilePageModule {}
